function acceptedGDPR({ state, output, services }) {
  const id = state.get('client.user._id')
  services.Http
    .post('/api/user/accept/gdpr', { id })
    .then(output.success)
    .catch(output.error)
}

acceptedGDPR.async = true
acceptedGDPR.outputs = ['success', 'error']

export default acceptedGDPR



// WEBPACK FOOTER //
// ./src/modules/login/actions/acceptGDPR.js